var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.ready
    ? _c(
        "app-mobile-full-screen-container",
        [
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              !_vm.$wf.isSmDown
                ? _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c(
                            "w-row",
                            { attrs: { "no-wrap": "" } },
                            [
                              _c("w-tabs", {
                                attrs: { tabs: _vm.tabs },
                                model: {
                                  value: _vm.tab,
                                  callback: function ($$v) {
                                    _vm.tab = $$v
                                  },
                                  expression: "tab",
                                },
                              }),
                              _c("w-spacer"),
                              _vm.hasLedgerModule
                                ? _c(
                                    "w-button",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: _vm.$ct("green-book"),
                                          expression: "$ct('green-book')",
                                        },
                                      ],
                                      staticClass: "edit-ledgers mr",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openLedgers()
                                        },
                                      },
                                    },
                                    [
                                      _c("w-fa", {
                                        staticClass: "ledger-icon mr",
                                        attrs: { icon: "book" },
                                      }),
                                      _vm._v(
                                        _vm._s(_vm.$ct("green-book-split")) +
                                          " "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.canCreateFixedAsset
                                ? _c(
                                    "w-button",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: _vm.$ct("create-fixed-asset"),
                                          expression:
                                            "$ct('create-fixed-asset')",
                                        },
                                      ],
                                      staticClass: "mr",
                                      on: {
                                        click: function ($event) {
                                          return _vm.createFixedAsset()
                                        },
                                      },
                                    },
                                    [
                                      _c("w-fa", {
                                        staticClass: "mr",
                                        attrs: { icon: "calculator" },
                                      }),
                                      _vm._v(
                                        _vm._s(_vm.$ct("fixed-asset")) + " "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "w-button",
                                {
                                  attrs: {
                                    icon: "check",
                                    disabled: _vm.saveDisabled,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.save()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$ct("common.save")) + " "
                                  ),
                                ]
                              ),
                              _vm.config.PurchaseAskForBankTransfer
                                ? _c(
                                    "w-button",
                                    {
                                      staticClass: "ml",
                                      attrs: {
                                        icon: "credit-card",
                                        disabled: _vm.saveDisabled,
                                      },
                                      on: {
                                        click: function ($event) {
                                          ;(_vm.openQuickBankEdit = true),
                                            _vm.save()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$ct("save-and-pay")) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "transition",
                { attrs: { name: "fast-fade", mode: "out-in" } },
                [
                  _vm.currentTabKey == "default"
                    ? _c(
                        "div",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12", md: "6" } },
                                [
                                  _c(
                                    "w-row",
                                    { attrs: { "no-margin": "" } },
                                    [
                                      _c(
                                        "w-col",
                                        {
                                          staticClass: "mb",
                                          attrs: { xs: "12", lg: "12" },
                                        },
                                        [
                                          _c("app-select-contact", {
                                            attrs: { value: _vm.value },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        {
                                          attrs: {
                                            xs: "12",
                                            lg: "6",
                                            grow: "",
                                          },
                                        },
                                        [
                                          _c("app-default", {
                                            ref: "default",
                                            attrs: { value: _vm.value },
                                            on: {
                                              "update-payment-percentage":
                                                function ($event) {
                                                  return _vm.updatePaymentPercentage(
                                                    $event
                                                  )
                                                },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", lg: "6" } },
                                        [
                                          _c("app-edit-vat", {
                                            attrs: { value: _vm.value },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                {
                                  style: { Height: "100%" },
                                  attrs: { xs: "12", lg: "6" },
                                },
                                [
                                  _c("app-purchase-documents", {
                                    attrs: { value: _vm.value },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm.currentTabKey == "extra-fields"
                    ? _c("app-purchase-edit-extra-fields", {
                        attrs: { value: _vm.value },
                      })
                    : _vm.tab >= _vm.extraFieldTabStart
                    ? _c("app-extra-field-tab", {
                        key: "extra-field-" + _vm.tab,
                        attrs: {
                          value: _vm.value.ExtraFields,
                          tab: _vm.extraFieldTabs[
                            _vm.tab - _vm.extraFieldTabStart
                          ],
                          "name-settings": _vm.extraFieldNamesConfig,
                        },
                      })
                    : _vm.currentTabKey == "purchase-validation"
                    ? _c(
                        "div",
                        [
                          _c(
                            "w-row",
                            { attrs: { "no-margin": "" } },
                            [
                              _c(
                                "w-col",
                                {
                                  style: {
                                    paddingTop: "0px",
                                    marginTop: "-8px",
                                  },
                                  attrs: { sm: "12", md: 6 + _vm.expand },
                                },
                                [
                                  _c("app-purchase-document-search-browse", {
                                    staticClass: "purchase-document-browse",
                                    attrs: {
                                      "override-static-view-select": true,
                                      "contact-id": _vm.value.ContactID,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { sm: "12", md: 6 - _vm.expand } },
                                [
                                  _c(
                                    "app-purchase-documents",
                                    { attrs: { value: _vm.value } },
                                    [
                                      _vm._t(
                                        "action-buttons",
                                        function () {
                                          return [
                                            _c("w-button", {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip",
                                                  value: _vm.$ct(
                                                    _vm.expand
                                                      ? "expand-screen"
                                                      : "compress-screen"
                                                  ),
                                                  expression:
                                                    "$ct(expand?'expand-screen':'compress-screen')",
                                                },
                                              ],
                                              staticClass: "compress flat",
                                              attrs: {
                                                icon: _vm.expand
                                                  ? "expand"
                                                  : "compress",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.expand = _vm.expand
                                                    ? 0
                                                    : 2
                                                },
                                              },
                                            }),
                                          ]
                                        },
                                        { slot: "action-buttons" }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              staticClass: "w100",
              attrs: { value: _vm.editLedgersOpen, "full-height": "" },
            },
            [
              _vm.editLedgersOpen
                ? _c("app-purchase-edit-ledgers-card", {
                    attrs: { purchase: _vm.value },
                    on: {
                      click: function ($event) {
                        _vm.editLedgersOpen = false
                      },
                      close: function ($event) {
                        _vm.editLedgersOpen = false
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              attrs: { value: _vm.quickBankEditPurchase != null },
              on: {
                input: function ($event) {
                  _vm.quickBankEditPurchase = null
                },
              },
            },
            [
              _vm.quickBankEditPurchase
                ? _c("app-bank-edit", {
                    attrs: { purchase: _vm.quickBankEditPurchase },
                    on: {
                      cancel: function ($event) {
                        ;(_vm.quickBankEditPurchase = null), _vm.onBankSave()
                      },
                      update: function ($event) {
                        _vm.quickBankEditPurchase = null
                      },
                      "bank-saved": function ($event) {
                        return _vm.onBankSave()
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }